var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Name"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.name}}),_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }